import { apiUrl, otaUrl } from "../api/endpoints";
import React, { useEffect, useState, Fragment, useContext } from 'react';
import axios from 'axios';
import './details.css';
import './edit.css';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/KeyboardOutlined';
import CloudUpload from '@mui/icons-material/CloudUploadOutlined';
import SaveIcon from '@mui/icons-material/SaveOutlined';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import FileIcon from '@mui/icons-material/TaskOutlined';
import ToggleOff from '@mui/icons-material/ToggleOffOutlined';
import ToggleOn from '@mui/icons-material/ToggleOnOutlined';
import { Tooltip } from '@mui/material';

import { DeleteIcon } from '../Icons';
import Select from 'react-select';
import './DownloadReportShared.css';
import DataGridTable from "../Components/DataGridTable";
import { useAuth } from '../hooks/AuthProvider';

import { LanguageContext } from '../context/LanguageContext';
import shipmentsTranslations from '../languages/shipment.json';
import { getErrorMessage } from '../utils/errorUtils';
import Alert from '../Components/Alert';

// const units = ['Hours', 'Minutes', 'Seconds'],
// firmwareKeys = ['file_size', 'md5_checksum', 'firmware_version', 'type', 'build'],
//     prefferedTimes = ['Any', 'Night (12AM - 6AM)', 'Morning (6AM - 12PM)', 'Afternoon (12PM - 6PM)', 'Evening (6PM - 12AM)'],
//     applyIfElements = ['Earlier build date', 'Another build date', 'Lower firmware version', 'No condition'];

export const CreateShipment = () => {
    const { permissions } = useAuth();
    const navigate = useNavigate();
    const { lang } = useContext(LanguageContext);

    const canCreateShipments = permissions['create_new_firmware_shipments'];

    const t = shipmentsTranslations[lang].createShipment;
    const isRtl = ['ar', 'ur'].includes(lang);
    const [alertState, setAlertState] = useState({
        open: false,
        message: '',
        type: 'info',
        position: isRtl ? 'left' : 'right'
    });
    const showAlert = (type, message) => {
        setAlertState({ open: true, type, message, position: isRtl ? 'left' : 'right' });
    };

    const units = t.units;
    const firmwareKeys = t.firmwareKeys;
    const prefferedTimes = t.preferredTimes;
    const applyIfElements = t.applyIfElements;


    const [templates, setTemplates] = useState([]);
    const [devices, setDevices] = useState([]);
    const [editName, setEditName] = useState(false);
    const [shippingData, setShippingData] = useState({
        id: 0,
        name: 'New Shipping',
        tid: '',
        template_name: '',
        dids: [],
        target_size: 0,
        preffered_time: 'Any',
        apply_if: 'Earlier build date',
        host: '',
        file: '',
        file_size: '',
        md5_checksum: '',
        firmware_version: '',
        type: '',
        build: '',
        attempts_limit: 3,
        attempts_reset_period: 24,
        attempts_reset_period_unit: 'Hours',
        notification: false,
        status: 'Live'
    });
    /*
const colors = {
    headerBackground: 'var(--header-background)',
    headerColor: 'var(--header-color)',
    headerHover: 'var(--header-hover)',
    cellBackground: 'var(--cell-background)',
    cellColor: 'var(--cell-color)',
    cellHover: 'var(--cell-hover)',
    orderColor: 'var(--order-color)',
    orderSelectedColor: 'rgb(49, 199, 149)',
    checkboxSelection: 'var(--accent)',
    btnBackground: 'rgb(219, 245, 236)',
    btnColor: 'var(--accent)',
    modalBorder: 'var(--modal-border)',
    red: 'rgb(236, 69, 78)'
}
*/


    const pagingoptions = [5, 10, 20, 50, 100];
    const fields = [
        { field: 'did', headerName: t.columns.did, width: 150, align: 'left', headerAlign: 'left', },
        { field: 'name', headerName: t.columns.name, width: 400, align: 'left', headerAlign: 'left' },
        {
            field: 'status', headerName: t.columns.status, width: 100, align: 'center', headerAlign: 'center',
            renderCell: (params) => (
                <div className='details-head' style={{ alignItems: 'center' }}>
                    <div className={`details-status ${params.row.status === 'Online' ? 'active' : null}`}></div>
                    {params.row.status}
                </div>
            )
        },
        { field: 'firmware', headerName: t.columns.firmware, width: 100, align: 'center', headerAlign: 'center' },
        { field: 'owner_name', headerName: t.columns.ownerName, width: 200, align: 'center', headerAlign: 'center' },
        {
            field: 'organization_name',
            headerName: t.columns.organizationName,
            width: 200,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (_value, row) =>
                row?.sub_organization_name || row?.organization_name || row?.main_organization_name || ''
        },
        { field: 'firmware_updated_on', headerName: t.columns.firmwareUpdatedOn, width: 200, align: 'center', headerAlign: 'center' },
    ];

    useEffect(() => {
        if (!canCreateShipments) return;

        const fetchTemplates = async () => {
            try {
                const res = await axios.get(apiUrl(`template/list`));

                if (res.data && res.data.status === 'OK' && Array.isArray(res.data.data)) {

                    const formattedTemplates = res.data.data.map(temp => ({
                        id: temp.tid,
                        name: temp.name
                    }));

                    setTemplates(formattedTemplates);

                } else {
                    throw new Error('Received an invalid response from the server.');
                }
            } catch (err) {
                console.log(err);
                const errorMessage = getErrorMessage(err);
                showAlert('error', `Failed to load templates: ${errorMessage}`);
                setTemplates([]);
            }
        };

        fetchTemplates();
    }, [canCreateShipments]);

    useEffect(() => {
        if (!canCreateShipments) return;

        const fetchAndFilterDevices = async () => {
            if (!shippingData.tid || shippingData.tid.length === 0) {
                setDevices([]);
                return;
            }

            try {
                const res = await axios.get(apiUrl('device/list'));

                const allDevices = res.data.data;

                if (Array.isArray(allDevices)) {
                    const filteredDevices = allDevices.filter(d => d.tid === shippingData.tid);
                    setDevices(filteredDevices);
                } else {
                    console.error("Received unexpected data format from /device/list:", res.data);
                    setDevices([]);
                }

            } catch (err) {
                const errorMessage = getErrorMessage(err);

                showAlert('error', `Failed to load devices: ${errorMessage}`);

                console.error(err);
                setDevices([]);
            }
        };

        fetchAndFilterDevices();
    }, [shippingData.tid, canCreateShipments]);

    const saveFile = async (e) => {
        if (!e.target.files || e.target.files.length === 0) {
            return;
        }

        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileName', file.name);
        formData.append('fileSize', file.size);


        try {
            const res = await axios.post(
                otaUrl(`file/upload`),
                formData
            );
            setShippingData({
                ...shippingData,
                file: file.name,
                file_size: res.data.FileSize,
                md5_checksum: res.data.MD5_Checksum,
                build: res.data.Build,
                firmware_version: res.data.Version,
                type: res.data.Firmware_Type
            });

            showAlert('success', 'Firmware file uploaded and parsed successfully.');

        } catch (err) {
            console.error("OTA file upload failed:", err);
            const errorMessage = getErrorMessage(err);
            showAlert('error', errorMessage);

            e.target.value = null;
        }
    };

    const createShipment = async () => {
        try {
            const payload = {
                ...shippingData,
                attempts_limit: parseInt(shippingData.attempts_limit, 10) || 0,
                attempts_reset_period: parseInt(shippingData.attempts_reset_period, 10) || 0
            };

            const res = await axios.post(
                otaUrl(`shipment/create`),
                payload,
                { headers: { "Content-Type": "application/json" } }
            );

            if (res.status === 201 && res.data.status === 'OK') {
                showAlert('success', 'Shipment created successfully!');
                navigate('/configuration/ota');
            } else {
                throw new Error('Received an unexpected response from the server.');
            }

        } catch (err) {
            console.error("Create Shipment Error:", err);
            const errorMessage = getErrorMessage(err);
            showAlert('error', errorMessage);
        }
    };
    const [selectedRows, setSelectedRows] = useState([]);
    const handleRowClick = (params) => {
    };

    const handleDeleteFile = async (isCancelAction = false) => {
        if (!shippingData.file || shippingData.file.length === 0) {
            if (isCancelAction) {
                navigate('/configuration/ota');
            }
            return;
        }

        try {
            const res = await axios.get(otaUrl(`file/delete/${shippingData.file}`));

            showAlert('success', res.data.message || 'File removed successfully.');

            if (isCancelAction) {
                navigate('/configuration/ota');
            } else {
                setShippingData(prev => ({ ...prev, file: '' }));
            }

        } catch (err) {
            const errorMessage = getErrorMessage(err);
            showAlert('error', errorMessage);

            if (isCancelAction) {
                navigate('/configuration/ota');
            }
        }
    };

    if (!canCreateShipments) {
        return (
            <div className='configuration'>
                <div className='config-header'>
                    <h2>Permission Denied</h2>
                </div>
                <div style={{ padding: '20px' }}>
                    <p>You do not have the required permission to create new firmware shipments.</p>
                </div>
            </div>
        );
    }

    return (
        <div className='details-container'>
            <Alert
                open={alertState.open}
                close={() => setAlertState({ ...alertState, open: false })}
                message={alertState.message}
                type={alertState.type}
                position={alertState.position}
            />
            <div className='details-control-panel'>
                <span className='details-control-btn'
                    onClick={() => handleDeleteFile(true)}>
                    <small>{'\u2715'}</small>
                </span>
            </div>
            <div className='details-content' style={{ padding: 0 }}>
                <div className='details-remain-head-part'
                    style={{ justifyContent: 'space-between', padding: 24, borderBottom: '1px solid var(--header-hover)' }}>
                    {editName ?
                        <div className='details-head'>
                            <input className='edit-name-input' type='text' defaultValue={shippingData.name} />
                            <div className='details-head'>
                                <span className='details-control-btn' onClick={() => {
                                    const input = document.querySelector('.edit-name-input'),
                                        newName = input.value;
                                    setShippingData({
                                        ...shippingData,
                                        name: newName
                                    });
                                    setEditName(false);
                                }}>
                                    <SaveIcon />
                                </span>
                                <span className='details-control-btn' onClick={() => setEditName(false)}>
                                    <CloseIcon />
                                </span>
                            </div>
                        </div>
                        : <div className='details-head'>
                            <h2>{shippingData.name}</h2>
                            <Tooltip title={'Edit name'} placement='right'>
                                <button className='details-actions-btn' style={{ color: 'var(--accent)' }}
                                    onClick={() => setEditName(true)}>
                                    <EditIcon style={{ fontSize: 'var(--small)' }} />
                                </button>
                            </Tooltip>
                        </div>}
                    <div className='details-head'>
                        <button className={`edit-btn edit-btn-save ${shippingData.file?.length > 0 && shippingData.tid?.length > 0 ? null : 'disabled'}`}
                            onClick={createShipment}>
                            {t.buttonStartShipping}</button>
                    </div>
                </div>
                <div className='details-body' style={{
                    flexDirection: 'column', padding: 12, overflowY: 'scroll', scrollbarWidth: 'thin'
                }}>
                    <div className='details-body-part shadow' style={{ gap: 0 }}>
                        <h2>{t.templateSelection}</h2>
                        <div className='details-part-content'>
                            <div className='edit-form-item' style={{ width: '100%' }}>
                                <label>{t.labelTemplate}</label>
                                <Select
                                    id="template_name"
                                    isRtl={isRtl}
                                    classNamePrefix="dr-select"
                                    options={templates.map((temp) => ({
                                        value: temp.id,
                                        label: temp.name
                                    }))}
                                    value={
                                        templates
                                            .map((temp) => ({
                                                value: temp.id,
                                                label: temp.name
                                            }))
                                            .find((option) => option.value === shippingData.tid) || null
                                    }
                                    onChange={(selectedOption) => {
                                        if (!selectedOption) {
                                            return;
                                        }

                                        const selectedTemplate = templates.find(
                                            (temp) => temp.id === selectedOption.value
                                        );

                                        if (selectedTemplate) {
                                            setShippingData(prev => ({
                                                ...prev,
                                                tid: selectedTemplate.id,
                                                template_name: selectedTemplate.name
                                            }));
                                        }
                                    }}
                                />
                            </div>
                            <div className='edit-form-item' style={{ width: '100%' }}>
                                <label>{t.labelPreferredTime}</label>
                                <Select
                                    id="preffered_time"
                                    isRtl={isRtl}
                                    classNamePrefix="dr-select"
                                    options={prefferedTimes.map((option) => ({
                                        value: option,
                                        label: option
                                    }))}
                                    value={
                                        shippingData.preffered_time
                                            ? {
                                                value: shippingData.preffered_time,
                                                label: shippingData.preffered_time
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        setShippingData({
                                            ...shippingData,
                                            preffered_time: selectedOption?.value || ''
                                        });
                                    }}
                                />
                            </div>
                            <div className='edit-form-item' style={{ width: '100%' }}>
                                <label>{t.labelApplyIf}</label>
                                <Select
                                    id="applyIf"
                                    isRtl={isRtl}
                                    classNamePrefix="dr-select"
                                    options={applyIfElements.map((option) => ({
                                        value: option,
                                        label: option
                                    }))}
                                    value={
                                        shippingData.apply_if
                                            ? {
                                                value: shippingData.apply_if,
                                                label: shippingData.apply_if
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        setShippingData({
                                            ...shippingData,
                                            apply_if: selectedOption?.value || ''
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {devices.length > 0 && (
                        <div
                            className='details-body-part shadow'
                            style={{
                                gap: 0,
                                minWidth: 0,
                                width: '100%',
                                boxSizing: 'border-box'
                            }}
                        >
                            <h2>{t.targetSelection}</h2>

                            <div
                                className='details-part-content'
                                style={{
                                    minWidth: 0,
                                    width: '100%',
                                    boxSizing: 'border-box'
                                }}
                            >
                                <div
                                    className="table-wrapper"
                                    style={{
                                        flex: 1,
                                        minWidth: 0,
                                        minHeight: 0,
                                        width: '100%',
                                        maxWidth: '100%',
                                        overflowX: 'auto',
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    <DataGridTable
                                        columns={fields}
                                        rows={devices}
                                        idcolumn={"did"}
                                        pagingoptions={pagingoptions}
                                        handleRowClick={handleRowClick}
                                        checkboxSelection={true}
                                        rowSelectionModel={selectedRows}
                                        setRowSelectionModel={(selDids) => {
                                            setSelectedRows(selDids);
                                            setShippingData(prev => ({
                                                ...prev,
                                                target_size: selDids.length,
                                                dids: selDids
                                            }));
                                        }}
                                        showToolbar={false}
                                        tableKey='createShipment'
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    <div className='details-body-part shadow' style={{ gap: 0 }}>
                        <h2>{t.firmware}</h2>
                        <div className='details-part-content'>
                            {shippingData.file?.length > 0 ?
                                <Fragment>
                                    <div style={{ position: 'relative', display: 'flex', width: '50%' }}>
                                        <input type='file' className='edit-logo-section' title=''
                                            accept={'.bin'} onChange={saveFile} />
                                        <div className='edit-delete-file'
                                            onClick={() => handleDeleteFile(false)}>
                                            <FileIcon style={{
                                                width: '100%',
                                                height: '60%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'var(--accent)',
                                                pointerEvents: 'none'
                                            }} />
                                            <div style={{
                                                position: 'absolute', top: '70%', width: '100%',
                                                fontSize: 'var(--large)', textAlign: 'center', pointerEvents: 'none'
                                            }}>
                                                {shippingData.file}
                                            </div>
                                        </div>
                                        <DeleteIcon />
                                    </div>
                                    <div style={{ width: '45%' }}>
                                        {firmwareKeys.map((key, idx) => (
                                            <div key={idx} style={{ display: 'flex', alignItems: "center", gap: 6, marginBottom: 12 }}>
                                                <span style={{ color: 'var(--header-color)', textTransform: 'uppercase' }}>
                                                    {t.firmwareKeys[idx]}:</span>
                                                <span style={{ color: 'var(--cell-color)' }}>{shippingData[key]}</span>
                                            </div>
                                        ))}
                                    </div>
                                </Fragment>
                                : <div style={{ position: 'relative', display: 'flex', width: '50%' }}>
                                    <input type='file' className='edit-logo-section' title=''
                                        accept={'.bin'} onChange={saveFile} />
                                    <div className='edit-delete-file' style={{ pointerEvents: 'none' }}>
                                        <CloudUpload style={{
                                            width: '100%',
                                            height: '60%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'var(--accent)',
                                            pointerEvents: 'none'
                                        }} />
                                        <div style={{
                                            position: 'absolute', top: '70%', width: '100%',
                                            fontSize: 'var(--large)', textAlign: 'center', pointerEvents: 'none'
                                        }}
                                            className='edit-helper'>
                                            {t.uploadHelper}
                                        </div>
                                    </div>
                                </div>}
                        </div>
                    </div>
                    <div className='details-body-part shadow' style={{ gap: 0 }}>
                        <h2>{t.settings}</h2>
                        <div className='details-part-content' style={{ flexDirection: 'column' }}>
                            <div className='details-part-content' style={{ width: '100%', padding: 0 }}>
                                <div className='details-head'>
                                    <div className='edit-form-item'>
                                        <label>{t.labelAttemptsLimit}</label>
                                        <input className='edit-form-input' type='text' placeholder={t.placeholderAttemptsLimit}
                                            value={shippingData.attempts_limit} onChange={
                                                (e) => setShippingData({
                                                    ...shippingData,
                                                    attempts_limit: e.target.value
                                                })} />
                                    </div>
                                </div>
                                <div className='details-head' style={{ width: '60%' }}>
                                    <div className='edit-form-item'>
                                        <label>{t.labelAttemptsResetPeriod}</label>
                                        <div style={{ display: 'flex' }}>
                                            <input className='edit-form-input' type='text' placeholder={t.labelAttemptsLimit}
                                                style={{ borderRadius: '4px 0 0 4px', backgroundColor: 'var(--cell-background)' }}
                                                value={shippingData.attempts_reset_period} onChange={
                                                    (e) => setShippingData({
                                                        ...shippingData,
                                                        attempts_reset_period: e.target.value
                                                    })} />
                                            <Select
                                                id="attempts_reset_period_unit"
                                                isRtl={isRtl}
                                                classNamePrefix="dr-select"
                                                options={units.map((option) => ({
                                                    value: option,
                                                    label: option
                                                }))}
                                                value={
                                                    shippingData.attempts_reset_period_unit
                                                        ? {
                                                            value: shippingData.attempts_reset_period_unit,
                                                            label: shippingData.attempts_reset_period_unit
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    setShippingData({
                                                        ...shippingData,
                                                        attempts_reset_period_unit: selectedOption?.value || ''
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='details-part-content'
                                style={{ width: '100%', padding: 0, justifyContent: 'flex-start' }}>
                                {shippingData.notification ?
                                    <ToggleOn style={{ fontSize: '40px', color: 'var(--accent)', cursor: 'pointer' }}
                                        onClick={() => setShippingData({ ...shippingData, notification: false })} /> :
                                    <ToggleOff style={{ fontSize: '40px', cursor: 'pointer' }}
                                        onClick={() => setShippingData({ ...shippingData, notification: true })} />}
                                <span className='edit-helper' style={{ fontWeight: '500' }}>
                                    {t.notificationHelper}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
